import { DataWidgetLayout } from "./data.view.widget";
import { useTheme } from "@me8eon/themes";
import React from "react";
import { EonUiLink } from "@eon-ui/eon-ui-components-react";
import { useUserData } from "@me8eon/react_authentication";
import { useTranslation } from "@me8eon/translation";

export const SimpleDataViewWidgetLayout: DataWidgetLayout = ({ children, rootId }) => {
    const { dataLayout } = useTheme();
    const [relevancyEnabled, setRelevancyEnabled] = React.useState(true);
    const { featureFlagEnabled } = useUserData();
    const t = useTranslation();
    const childWithProperties = React.cloneElement(children as React.ReactElement, {
        relevancyEnabled
    });
    return (
        <div data-testid={`${rootId}-layout`} style={dataLayout.AdvanceUnifiedBox}>
            <div className="unified-box-heading">
                {t("searchResult")}
                {featureFlagEnabled && <EonUiLink
                    data-testid={`${rootId}-about-me8eon`}
                    size="small"
                    slot="links"
                    target="_blank"
                    text={relevancyEnabled ? t("showAll") : t("showRelevant")}
                    onClick={() => setRelevancyEnabled(!relevancyEnabled)}
                    aria-label={relevancyEnabled ? t("showAll") : t("showRelevant")}
                />}
            </div>
            <div className="unified-box-content">{childWithProperties}</div>
        </div>
    );
};
